// Бэкенд хранит datetime naive в UTC (контейнеры в UTC) и отдаёт ISO-строки
// без таймзоны. Для production-кабинета physician даты показываются в
// ЛОКАЛЬНОЙ таймзоне браузера — «во сколько по моему времени был проведён тест».

export function parseUtc(iso: string): Date {
  const hasTz = /Z$|[+-]\d{2}:?\d{2}$/.test(iso);
  return new Date(hasTz ? iso : iso + "Z");
}

export function formatLocalDateTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = parseUtc(iso);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function browserTimeZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "Asia/Almaty";
  } catch {
    return "Asia/Almaty";
  }
}
